module.exports = __webpack_public_path__ + "static/nasa2-e51b42952345b2364f84972cd6655440.gif";